// extracted by mini-css-extract-plugin
export default {"wrapper":"MapViewLayout_wrapper__f4BM0"};